<template>
  <div>
    <table class="table table-striped" style="border-bottom: 1px solid #dee2e6">
      <tbody>
        <tr>
          <td>Maintenance Date</td>
          <td else>{{ formatDate(maintenanceDetailData.maintenanceDate) }}</td>
        </tr>
        <tr v-if="maintenanceDetailData.trigger === 'COUNTER'">
          <td>Maintenance Running Hours</td>
          <td
            ><p v-if="maintenanceDetailData.trigger === 'COUNTER'"
              >{{ maintenanceDetailData.lastMaintenanceHours }} HOURS</p
            ></td
          >
        </tr>
        <tr>
          <td>Attachment</td>
          <td
            ><b-badge
              variant="warning"
              class="cursor-pointer"
              @click="
                handleOpenFilePreview(
                  maintenanceDetailData?.file?.url,
                  maintenanceDetailData?.file?.fileName
                )
              "
              >{{ maintenanceDetailData?.file?.fileName }}</b-badge
            ></td
          >
        </tr>
        <tr>
          <td>Cost</td>
          <td>Rp.{{ numberFormat(maintenanceDetailData.cost) }}</td>
        </tr>
        <tr v-if="maintenanceDetailData?.poponedDate">
          <td>Posponed Date</td>
          <td else>{{ formatDate(maintenanceDetailData?.poponedDate) }}</td>
        </tr>
        <tr v-if="maintenanceDetailData?.posponedRh">
          <td>Pospones (RH)</td>
          <td else>{{ maintenanceDetailData?.posponedRh ?? '-' }}</td>
        </tr>
        <tr>
          <td class="align-top">Current Notes</td>
          <td colspan="4">
            <span v-if="maintenanceDetailData.status === 'APPROVE'">{{
              maintenanceDetailData.finishNotes
            }}</span>
            <span v-else>{{ maintenanceDetailData.notes }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import { numberFormat, previewFile } from '@/src/plugins/helpers'
import { saveAs } from 'file-saver'

export default {
  name: 'MaintenanceInfoDetail',
  props: {
    maintenanceDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    numberFormat,
    handleOpenFilePreview(url, fileName) {
      saveAs(url, fileName)
    },
    formatDate(date) {
      return date ? moment(date, 'DD-MM-YYYY').format('DD/MM/YYYY') : '-'
    },
  },
}
</script>

<style scoped>
.font-medium {
  font-weight: 500;
}
</style>
